  <page-load-header *ngIf="!initialized"></page-load-header>
  <div class="body-inner">

    <header>
      <div class="container cs_header">
        <div class="cs_logo">
          <img src="./assets/img/assessment/logo.png" alt="logo" />
        </div>
        <!--<button class="cs_btn orange"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M13 14.3V15C13 15 11.2 15 11 15V14.4C11 13.8 11.1 13 11.8 12.3C12.5 11.6 13.4 11.1 13.4 10.2C13.4 9.3 12.7 8.8 12 8.8C10.7 8.8 10.6 10.2 10.5 10.5H8.6C8.6 9.1 9.2 7 12 7C14.4 7 15.4 8.6 15.4 10C15.4 12.4 13 12.8 13 14.3Z" fill="currentColor" /><path d="M12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z" fill="currentColor" /><path d="M12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z" fill="currentColor" /></svg> Support</button>-->
      </div>
    </header>

    <div class="container cs_page">
      <h1 *ngIf="currentStep != 13">Running Form Assessment</h1>

      <div class="cs_stepper"  *ngIf="currentStep != 13">
        <div class="cs_step-item"
             [class.active]="currentStep === 0"
             [class.sub-step]="currentStep === 1 || visitedSteps[1]"
             [class.complete]="visitedSteps[0] && currentStep > 0 && !isPageInvalid(0)"
             [class.disabled]="!visitedSteps[0]"
             [class.visited]="visitedSteps[0]"
             [class.error]="isPageInvalid(0)">
          <div class="cs_step-item-status" (click)="goToStep(0)">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M23.1003 10.0744C23.104 10.076 23.1109 10.08 23.1198 10.0887L24.7018 11.7267L24.7044 11.7293V11.7332L12.6159 23.0301L12.6016 23.0197L6.9349 17.1616L6.93359 17.159V17.1538L8.51302 15.6304L8.51562 15.6277H8.52083L12.2669 19.4559L12.612 19.8074L12.9714 19.4715L23.0547 10.0744C23.0634 10.0733 23.0762 10.0731 23.0938 10.0731C23.0944 10.0731 23.0968 10.0729 23.1003 10.0744Z" fill="currentColor" /></svg></div>
          <div class="cs_step-item-label">
            Submission
          </div>
          <div class="cs_substep-item" (click)="goToStep(1); $event.stopPropagation()" [class.visited]="visitedSteps[1]" [class.error]="isPageInvalid(1)"></div>
        </div>

        <div class="cs_step-item"
               [class.active]="currentStep === 2"
               [class.complete]="visitedSteps[2] && currentStep > 2"
               [class.disabled]="!visitedSteps[2]"
               [class.visited]="visitedSteps[2]"
               (click)="goToStep(2)"
               [class.error]="isPageInvalid(2)">
          <div class="cs_step-item-status"><svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M23.1003 10.0744C23.104 10.076 23.1109 10.08 23.1198 10.0887L24.7018 11.7267L24.7044 11.7293V11.7332L12.6159 23.0301L12.6016 23.0197L6.9349 17.1616L6.93359 17.159V17.1538L8.51302 15.6304L8.51562 15.6277H8.52083L12.2669 19.4559L12.612 19.8074L12.9714 19.4715L23.0547 10.0744C23.0634 10.0733 23.0762 10.0731 23.0938 10.0731C23.0944 10.0731 23.0968 10.0729 23.1003 10.0744Z" fill="currentColor" /></svg></div>
          <div class="cs_step-item-label">Level Up</div>
        </div>

        <div class="cs_step-item"
              [class.active]="currentStep === 3"
              [class.complete]="visitedSteps[3] && currentStep > 3"
              [class.disabled]="!visitedSteps[3]"
              [class.visited]="visitedSteps[3]"
               (click)="goToStep(3)"
              [class.error]="isPageInvalid(3)">
          <div class="cs_step-item-status" >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M23.1003 10.0744C23.104 10.076 23.1109 10.08 23.1198 10.0887L24.7018 11.7267L24.7044 11.7293V11.7332L12.6159 23.0301L12.6016 23.0197L6.9349 17.1616L6.93359 17.159V17.1538L8.51302 15.6304L8.51562 15.6277H8.52083L12.2669 19.4559L12.612 19.8074L12.9714 19.4715L23.0547 10.0744C23.0634 10.0733 23.0762 10.0731 23.0938 10.0731C23.0944 10.0731 23.0968 10.0729 23.1003 10.0744Z" fill="currentColor" /></svg></div>
          <div class="cs_step-item-label">
            Runner Profile
          </div>

        </div>

        <div class="cs_step-item"
              [class.active]="currentStep === 4"
              [class.sub-step]="currentStep === 5 || visitedSteps[5]"
              [class.complete]="visitedSteps[4] && currentStep > 4 && !isPageInvalid(4)"
              [class.disabled]="!visitedSteps[4]"
              [class.visited]="visitedSteps[4]"
               (click)="goToStep(4)"
              [class.error]="isPageInvalid(4)">
          <div class="cs_step-item-status" >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M23.1003 10.0744C23.104 10.076 23.1109 10.08 23.1198 10.0887L24.7018 11.7267L24.7044 11.7293V11.7332L12.6159 23.0301L12.6016 23.0197L6.9349 17.1616L6.93359 17.159V17.1538L8.51302 15.6304L8.51562 15.6277H8.52083L12.2669 19.4559L12.612 19.8074L12.9714 19.4715L23.0547 10.0744C23.0634 10.0733 23.0762 10.0731 23.0938 10.0731C23.0944 10.0731 23.0968 10.0729 23.1003 10.0744Z" fill="currentColor" /></svg></div>
          <div class="cs_step-item-label">
            Injury
          </div>
          <div class="cs_substep-item" (click)="goToStep(5); $event.stopPropagation()" [class.visited]="visitedSteps[5]" [class.error]="isPageInvalid(5)"></div>
        </div>


        <div class="cs_step-item"
           [class.active]="currentStep === 6"
           [class.complete]="visitedSteps[6] && visitedSteps[12]  && currentStep > 12 && !isPageInvalid(6)&& !isPageInvalid(7)&& !isPageInvalid(8)&& !isPageInvalid(9)&& !isPageInvalid(10)&& !isPageInvalid(11)&& !isPageInvalid(12)"
           [class.disabled]="!visitedSteps[6]"
           [class.visited]="visitedSteps[6]"
           (click)="goToStep(6)"
           [class.error]="isPageInvalid(7) || isPageInvalid(8) || isPageInvalid(9)|| isPageInvalid(10) || isPageInvalid(11)|| isPageInvalid(12) ">
          <div class="cs_step-item-status" >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M23.1003 10.0744C23.104 10.076 23.1109 10.08 23.1198 10.0887L24.7018 11.7267L24.7044 11.7293V11.7332L12.6159 23.0301L12.6016 23.0197L6.9349 17.1616L6.93359 17.159V17.1538L8.51302 15.6304L8.51562 15.6277H8.52083L12.2669 19.4559L12.612 19.8074L12.9714 19.4715L23.0547 10.0744C23.0634 10.0733 23.0762 10.0731 23.0938 10.0731C23.0944 10.0731 23.0968 10.0729 23.1003 10.0744Z" fill="currentColor" /></svg></div>
          <div class="cs_step-item-label">
            Runner Movement
          </div>
        </div>
      </div>


      <form class="form" [formGroup]="formGroup" novalidate>

        <!--------------------------->
        <!-- Page  0 -->
        <!--------------------------->
        <div *ngIf="currentStep === 0" class="content">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Information</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs-row cs-col-2">
                <div class="cs_input-item" [class.has-error]="formGroup.controls['firstName'].dirty && formGroup.controls['firstName'].errors">
                  <label class="cs_input-label"><span class="required">*</span> First Name</label>
                  <input type="text" formControlName="firstName" maxlength="150" id="firstName" placeholder="First Name" />
                  <div *ngIf="formGroup.controls['firstName'].dirty && formGroup.controls['firstName'].errors" class="error-message">Required field</div>
                </div>

                <div class="cs_input-item" [class.has-error]="formGroup.controls['lastName'].dirty && formGroup.controls['lastName'].errors">
                  <label class="cs_input-label"><span class="required">*</span> Last Name</label>
                  <input type="text" placeholder="Last Name" formControlName="lastName" maxlength="150" id="lastName" />
                  <div class="error-message">Required field</div>
                </div>
              </div>

              <div class="cs-row">
                <div class="cs_input-item" [class.has-error]="formGroup.controls['publicUserEmail'].dirty && formGroup.controls['publicUserEmail'].errors">
                  <label class="cs_input-label"><span class="required">*</span> Email</label>
                  <input type="email" placeholder="Enter your email" formControlName="publicUserEmail" id="publicUserEmail" maxlength="75" />
                  <div class="error-message">Provide correct email address</div>
                </div>
              </div>

              <div class="cs-row">
                <div class="cs_input-item" [class.has-error]="formGroup.controls['runnerHeight'].dirty && formGroup.controls['runnerHeight'].errors">
                  <label class="cs_input-label"><span class="required">*</span> Runner Height</label>
                  <div class="cs_input-group">
                    <input type="number" placeholder="Height (e.g., 70.5)" formControlName="runnerHeight" (input)="onDecimalInput($event)" inputmode="decimal">
                    <div class="cs_btn-toggle">
                      <input type="radio" name="heightUnit" id="lb" [checked]="formGroup.get('heightUnit')?.value === 1" hidden>
                      <input type="radio" name="heightUnit" id="kg" [checked]="formGroup.get('heightUnit')?.value === 2" hidden>

                      <div class="cs_btn-toggle-item"
                           [class.active]="formGroup.get('heightUnit')?.value === 2"
                           (click)="formGroup.get('heightUnit')?.setValue(2)">Inches</div>

                      <div class="cs_btn-toggle-item"
                           [class.active]="formGroup.get('heightUnit')?.value === 1"
                           (click)="formGroup.get('heightUnit')?.setValue(1)">Cm</div>
                    </div>
                  </div>
                  <div class="error-message">Provide correct height</div>
                </div>
              </div>

              <div class="cs-row">
                <div class="cs_input-item" [class.has-error]="formGroup.controls['runnerWeight'].dirty && formGroup.controls['runnerWeight'].errors">
                  <label class="cs_input-label"><span class="required">*</span> Runner Weight</label>
                  <div class="cs_input-group">
                    <input type="number" placeholder="Weight (e.g., 154)" formControlName="runnerWeight" (input)="onDecimalInput($event)" inputmode="decimal" />
                    <div class="cs_btn-toggle">
                      <input type="radio" name="weightUnit" id="lb" [checked]="formGroup.get('weightUnit')?.value === 1" hidden>
                      <input type="radio" name="weightUnit" id="kg" [checked]="formGroup.get('weightUnit')?.value === 2" hidden>

                      <div class="cs_btn-toggle-item"
                           [class.active]="formGroup.get('weightUnit')?.value === 1"
                           (click)="formGroup.get('weightUnit')?.setValue(1)">Lb</div>

                      <div class="cs_btn-toggle-item"
                           [class.active]="formGroup.get('weightUnit')?.value === 2"
                           (click)="formGroup.get('weightUnit')?.setValue(2)">Kg</div>
                    </div>
                  </div>
                  <div class="error-message">Provide correct weight</div>
                </div>
              </div>

              <div class="cs-row">
                <div class="cs_input-item">
                  <label class="cs_input-label">Shoes</label>
                  <input type="text" placeholder="What brand and model of shoes do you use?" formControlName="shoes" id="shoes" maxlength="150" />
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  1 -->
        <!--------------------------->
        <div class="content" *ngIf="currentStep === 1">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Recording Guidelines</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs-row">
                <p>
                  For the best results, your videos <b class="font-weight-500">MUST</b> meet these criteria:
                </p>
                <ul>
                  <li>Keep the camera steady.</li>
                  <li>Record at 60 fps (30 fps gives less accurate results).</li>
                  <li>Film a full-body video directly from the side and back (not at an angle)</li>
                  <li>Run on flat, solid ground or a treadmill (not grass).</li>
                  <li>Ensure at least 6 steps are visible in the frame.</li>
                </ul>
              </div>
            </div>
          </div>

          <div formArrayName="videos" class="" *ngFor="let video of videos.controls; let v = index; trackBy: trackByIndex">
            <div class="cs_panel">
              <div class="cs_panel-header">
                <h3 *ngIf="v === 0">Side View Run</h3>
                <h3 *ngIf="v === 1">Back View Run</h3>
              </div>
              <div class="cs_panel-body cs_gap-2">
                <div *ngIf="v === 0" class="cs_show-tutorial-container">
                  <button class="cs_btn transparent" (click)="toggleSideVideoInstruction()"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.3608 8.99585L11.9995 16.3572L4.63818 8.99585L5.99268 7.64136L11.9995 13.6482L12.2407 13.408L18.0063 7.64136L19.3608 8.99585Z" fill="currentColor" /></svg> Show Tutorial</button>
                  <div class="cs_expand" [class.active]="showSideVideoInstruction">
                    <div class="video-placeholder">
                      <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/15c7fd9a-4d31-4f6a-b3e9-cc10e46a9baa/playlist.m3u8'" [size]="'large'"></embed-video-player>
                    </div>
                  </div>
                </div>
                <div *ngIf="v === 1" class="cs_show-tutorial-container">
                  <button class="cs_btn transparent" (click)="toggleBackVideoInstruction()"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19.3608 8.99585L11.9995 16.3572L4.63818 8.99585L5.99268 7.64136L11.9995 13.6482L12.2407 13.408L18.0063 7.64136L19.3608 8.99585Z" fill="currentColor" /></svg> Show Tutorial</button>
                  <div class="cs_expand" [class.active]="showBackVideoInstruction">
                    <div class="video-placeholder">
                      <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/13f7fdf5-3cb3-4cd7-8b76-e55c12420c2d/playlist.m3u8'" [size]="'large'"></embed-video-player>
                    </div>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="formGroup.controls['videos'].dirty && formGroup.controls['videos'].errors">
                  <p *ngIf="v === 0">Please upload a 3-5 second side-view video of your run. (Max 100MB). </p>
                  <p *ngIf="v === 1">Please upload a 3-5 second back-view video of your run. (Max 100MB). </p>
                  <div>
                    <div class="" [formGroupName]="v">
                      <div class="btn-over">
                        <video-upload *ngIf="!video.get('id').value"
                                      [label]="v === 0 ? '* Video ' + (v + 1) + ' - Side View Left or Right 3-5 seconds, UP to 100Mb' : '* Video ' + (v + 1) + ' - Back View 3-5 seconds, UP to 100Mb'"
                                      [allowAnonymous]="true"
                                      [showLabel]="false"
                                      [validateCameraUse]="true"
                                      formControlName="videoId">
                        </video-upload>
                      </div>
                    </div>
                  </div>
                  <div class="error-message">Upload both videos</div>
                </div>
              </div>
            </div>
          </div>


          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Agreements</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs-row">
                <div class="cs_input-item checkbox">
                  <label class="cs_checkbox" for="acceptTerm">
                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M13.6183 1.4052C13.8296 1.58306 13.8567 1.89854 13.6788 2.1098L5.64988 11.644C5.27242 12.0922 4.59221 12.1213 4.17786 11.707L0.146446 7.67554C-0.0488157 7.48027 -0.0488154 7.16369 0.146447 6.96843L1.56043 5.55444C1.7557 5.35918 2.07228 5.35918 2.26754 5.55444L4.75774 8.04464L11.384 0.177897C11.5618 -0.0332524 11.8772 -0.060299 12.0884 0.11748L13.6183 1.4052Z" fill="currentColor" /></svg>
                  </label>

                  <label>
                    <input type="checkbox" id="acceptTerm" hidden formControlName="acceptTerm">
                    <span class="required">*</span> I agree to the Terms of <a href="javascript:void(0)" (click)="onViewTerms()">Service and Privacy policy </a>
                  </label>
                  <div class="error-message">Required field</div>
                </div>

                <div class="cs_input-item checkbox">
                  <label class="cs_checkbox" for="allowUse">
                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none"><path d="M13.6183 1.4052C13.8296 1.58306 13.8567 1.89854 13.6788 2.1098L5.64988 11.644C5.27242 12.0922 4.59221 12.1213 4.17786 11.707L0.146446 7.67554C-0.0488157 7.48027 -0.0488154 7.16369 0.146447 6.96843L1.56043 5.55444C1.7557 5.35918 2.07228 5.35918 2.26754 5.55444L4.75774 8.04464L11.384 0.177897C11.5618 -0.0332524 11.8772 -0.060299 12.0884 0.11748L13.6183 1.4052Z" fill="currentColor" /></svg>
                  </label>
                  <label>
                    <input type="checkbox" id="allowUse" hidden formControlName="allowUse">
                    <span class="required">*</span> I understand my videos may be used to improve RunDNA's Running Form Analysis
                    Tools
                  </label>
                  <div class="error-message">Required field</div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please fill all fields</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  2 -->
        <!--------------------------->
        <div *ngIf="currentStep === 2" class="content">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Level up Assessment</h3>
            </div>
            <div class="cs_panel-body">
              <p>The video below outlines how additional information can be used to level up your report. This typically takes between 2-5 minutes to complete. This is optional and you can choose below to expand on your profile or opt out.</p>
              <div class="video-placeholder">
                <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/ef938391-97e4-425c-86d4-304262971909/playlist.m3u8'" [size]="'large'"></embed-video-player>
              </div>
                <button class="cs_btn outline" (click)="onEarlySave(false)" [promiseBtn]="submitComplete">Skip and Finish</button>
            </div>
          </div>
        </div>

      </form>


      <form class="form" [formGroup]="formGroupProfile" novalidate>

        <!--------------------------->
        <!-- Page  3 -->
        <!--------------------------->
        <div *ngIf="currentStep === 3" class="content">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Build your Runner Profile</h3>
            </div>
            <div class="cs_panel-body">
              <p>This section allows you to share additional information to understand your background as a runner to further individualize your report.</p>
            </div>
          </div>
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Training Habits</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs_input-item">
                <p>How many years of experience running do you have?</p>

                <div class="cs_btn-toggle">
                  <ng-container *ngFor="let option of yearsOfExperienceEnum">
                    <input type="radio"
                           hidden
                           formControlName="yearsOfExperience"
                           [value]="option.value"
                           [id]="'yearsExp_' + option.value" />

                    <div class="cs_btn-toggle-item"
                         [attr._target]="'yearsExp_' + option.value"
                         (click)="onSelectYoe(option.value)"
                         [class.active]="formGroupProfile.get('yearsOfExperience')?.value === option.value">
                      {{ option.label }}
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="cs_input-item">
                <p>How many days per week are you currently running?</p>
                <div class="cs_btn-toggle">
                  <ng-container *ngFor="let day of [1,2,3,4,5,6,7]">
                    <input type="radio"
                           hidden
                           formControlName="daysPerWeekRunning"
                           [id]="'daysPerWeekRunning' + day"
                           [value]="day" />

                    <div class="cs_btn-toggle-item"
                         [attr._target]="'daysPerWeekRunning' + day"
                         (click)="onSelectDayWeek(day)"
                         [class.active]="formGroupProfile.get('daysPerWeekRunning')?.value === day">
                      {{ day }}
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Profile Details</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['runnerAge'].dirty && formGroupProfile.controls['runnerAge'].errors">
                <label class="cs_input-label"><span class="required">*</span> What is your current age?</label>
                <input type="number" min="2" max="100" placeholder="e.g., 32" formControlName="runnerAge" id="runnerAge" />
                <div class="error-message">Provide correct age</div>
              </div>
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['gender'].dirty && formGroupProfile.controls['gender'].errors">
                <label class="cs_input-label"><span class="required">*</span> What is your gender?</label>
                <select name="gender" id="gender" formControlName="gender" aria-placeholder="select">
                  <option disabled selected value="null">Select an option</option>
                  <option *ngFor="let option of genderEnum" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="error-message">Required field</div>
              </div>
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['slowdownFactor'].dirty && formGroupProfile.controls['slowdownFactor'].errors">
                <label class="cs_input-label"><span class="required">*</span> What is the first thing you notice in a race or when running hard that causes you to slow down?</label>
                <select name="slowdownFactor" id="slowdownFactor" formControlName="slowdownFactor" aria-placeholder="select">
                  <option disabled selected value="null">Select an option</option>
                  <option *ngFor="let option of runnerSlowdownFactorEnum" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="error-message">Required field</div>
              </div>
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['motivation'].dirty && formGroupProfile.controls['motivation'].errors">
                <label class="cs_input-label"><span class="required">*</span> What's your primary motivation to run?</label>
                <select name="motivation" id="motivation" formControlName="motivation" aria-placeholder="select">
                  <option disabled selected value="null">Select an option</option>
                  <option *ngFor="let option of runnerMotivationEnum" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="error-message">Required field</div>
              </div>
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['targetRace'].dirty && formGroupProfile.controls['targetRace'].errors">
                <label class="cs_input-label"><span class="required">*</span> What is the upcoming target race that you're training for?</label>
                <select name="targetRace" id="targetRace" formControlName="targetRace" aria-placeholder="select">
                  <option disabled selected value="null">Select an option</option>
                  <option *ngFor="let option of targetRaceTypeEnum" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="error-message">Required field</div>
              </div>
              <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['runningFormApproach'].dirty && formGroupProfile.controls['runningFormApproach'].errors">
                <label class="cs_input-label"><span class="required">*</span> Which of the following best describes your approach to running and running form?</label>
                <select name="runningFormApproach" id="runningFormApproach" formControlName="runningFormApproach" aria-placeholder="select">
                  <option disabled selected value="null">Select an option</option>
                  <option *ngFor="let option of runningFormApproachEnum" [ngValue]="option.value">
                    {{ option.label }}
                  </option>
                </select>
                <div class="error-message">Required field</div>
              </div>
            </div>
          </div>
        </div>

        <!--------------------------->
        <!-- Page  4 -->
        <!--------------------------->
        <div *ngIf="currentStep === 4" class="content ">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Current Injuries</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs-row">
                <div class="cs_select-group">
                  <p>Do you have any current running-related injuries or pain while running?</p>
                  <div class="cs_btn-group">
                    <button class="cs_btn" [ngClass]="{'primary': formGroupProfile.get('hasCurrentInjury')?.value === false,
                                  'secondary': formGroupProfile.get('hasCurrentInjury')?.value !== false
                                }" (click)="formGroupProfile.get('hasCurrentInjury')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn" [ngClass]="{'primary': formGroupProfile.get('hasCurrentInjury')?.value === true,
                                  'secondary': formGroupProfile.get('hasCurrentInjury')?.value !== true
                                }" (click)="formGroupProfile.get('hasCurrentInjury')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Injury Details</h3>
              <h5 class="inj-font-defails">If you have multiple current injuries, report information for the injury that is causing the most pain/discomfort</h5>
            </div>
            <div class="cs_panel-body">
              <div class="cs_injury-item">
                <!--<h3>Injury</h3>-->
                <!--<button class="cs_icon">{icon=delete}</button>-->
              </div>
              <div class="cs-row">
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasCurrentInjury')?.value === true" class="required">*</span> Where is the injury or pain located?</label>
                  <select formControlName="currentInjurySite" name="currentInjurySite" id="currentInjurySite" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injurySiteEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasCurrentInjury')?.value === true" class="required">*</span> What side is the injury or pain?</label>
                  <select formControlName="currentInjurySide" name="currentInjurySide" id="currentInjurySide" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injurySideEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasCurrentInjury')?.value === true" class="required">*</span> What impact does the injury have on the amount you are running?</label>
                  <select formControlName="currentInjuryImpact" name="currentInjuryImpact" id="currentInjuryImpact" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injuryImpactEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  5 -->
        <!--------------------------->
        <div *ngIf="currentStep === 5" class="content">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Previous Injuries</h3>
            </div>
            <div class="cs_panel-body">
              <div class="cs-row">
                <div class="cs_select-group">
                  <p>If you had multiple previous injuries, report information for the injury that is causing the most pain/discomfort</p>
                  <div class="cs_btn-group">
                    <button class="cs_btn" [ngClass]="{'primary': formGroupProfile.get('hasPastInjury')?.value === false,
                                  'secondary': formGroupProfile.get('hasPastInjury')?.value !== false
                                }" (click)="formGroupProfile.get('hasPastInjury')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn" [ngClass]="{'primary': formGroupProfile.get('hasPastInjury')?.value === true,
                                  'secondary': formGroupProfile.get('hasPastInjury')?.value !== true
                                }" (click)="formGroupProfile.get('hasPastInjury')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Injury Details</h3>
              <h5 class="inj-font-defails">If you had multiple current injuries, report information for the injury that is causing the most pain/discomfort</h5>
            </div>
            <div class="cs_panel-body">
              <div class="cs_injury-item">
                <!--<h3>Injury</h3>-->
                <!--<button class="cs_icon">{icon=delete}</button>-->
              </div>
              <div class="cs-row">
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasPastInjury')?.value === true" class="required">*</span> Where was the injury or pain located?</label>
                  <select formControlName="pastInjurySite" name="pastInjurySite" id="pastInjurySite" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injurySiteEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasPastInjury')?.value === true" class="required">*</span> What side was the injury or pain?</label>
                  <select formControlName="pastInjurySide" name="pastInjurySide" id="pastInjurySide" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injurySideEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasPastInjury')?.value === true" class="required">*</span> What impact did the injury have on the amount you were running?</label>
                  <select formControlName="pastInjuryImpact" name="pastInjuryImpact" id="pastInjuryImpact" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injuryImpactPastEnum" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item">
                  <label class="cs_input-label"><span *ngIf="formGroupProfile.get('hasPastInjury')?.value === true" class="required">*</span> When did this injury/pain occur?</label>
                  <select formControlName="injuredAgo" name="injuredAgo" id="injuredAgo" aria-placeholder="select">
                    <option disabled selected value="null">Select an option</option>
                    <option *ngFor="let option of injuredAgo" [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                  <div class="error-message">Error Message</div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  6 -->
        <!--------------------------->
        <div *ngIf="currentStep === 6" class="content">
          <div class="cs_panel">
            <div class="cs_panel-header">
              <h3>Runner Movement Screen</h3>
            </div>
            <div class="cs_panel-body">
              <p>This final step is an optional 6-part movement assessment. This data will add personalized insights about your strength and flexibility to your report. Click 'Next' to begin, or 'Skip & Finish' to complete your assessment now.</p>
              <div class="video-placeholder"> <embed-video-player [encoded]="true" [privateVideo]="true" [azureUrl]="'https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/749af790-492f-488c-9d9a-b413206e239f/playlist.m3u8'" [size]="'large'"></embed-video-player></div>
              <button class="cs_btn outline" (click)="onEarlySaveAssessmentAndProfile()" [promiseBtn]="submitComplete">Skip and Finish</button>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  7 -->
        <!--------------------------->
        <div *ngIf="currentStep === 7" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item active"  [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]" (click)="goToStep(7)">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]" (click)="goToStep(8)">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item  cs-not-visited" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]" (click)="goToStep(9)">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]" (click)="goToStep(10)">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]" (click)="goToStep(11)">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]" (click)="goToStep(12)">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Hip Mobility</h3>
                <div class="cs_step-label"> Step 1 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video" (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/df07d49e-b344-4e14-a94f-c2a3708a567a/playlist.m3u8', 'Hip Mobility Instruction')">
                  <div class="cs_play-video-label">
                    Check Movement Instructions
                  </div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Can you complete the movement by getting into the stretch position with your left knee on
                    the ground and touching your bottom to your heel?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityLeft')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityLeft')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityLeft')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityLeft')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while completing the movement with your left knee on the
                    ground?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityLeftPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityLeftPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityLeftPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityLeftPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Can you complete the movement by getting into the stretch position with your right knee
                    on the ground and touching your bottom to your heel?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityRight')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityRight')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityRight')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityRight')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while completing the movement with your right knee on the
                    ground?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityRightPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityRightPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipMobilityRightPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipMobilityRightPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  8 -->
        <!--------------------------->
        <div *ngIf="currentStep === 8" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item complete" (click)="goToStep(7)" [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item active" (click)="goToStep(8)" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item  cs-not-visited" (click)="goToStep(9)" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(10)" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(11)" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(12)" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Single Leg Sit to Stand</h3>
                <div class="cs_step-label"> Step 2 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video" (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/64fbfa08-c47d-4759-9c06-bc47f3420374/playlist.m3u8', 'Single Leg Sit to Stand Instruction')">
                  <div class="cs_play-video-label">
                    Check Movement Instructions
                  </div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['lowerBodyStabilityCountsLeft'].dirty && formGroupProfile.controls['lowerBodyStabilityCountsLeft'].errors">
                  <div class="cs_select-group">
                    <p><span class="required">*</span> How many single leg sit to stands on your left leg can you complete up to 10? </p>
                    <div class="cs_btn-group fill">
                      <input type="number" placeholder="e.g. 7" min="0" formControlName="lowerBodyStabilityCountsLeft" id="lowerBodyStabilityCountsLeft" />
                    </div>
                  </div>

                  <div class="error-message">Provide correct value</div>
                </div>
                <div class="cs_select-group">
                  <p><span class="required">*</span> Did you experience any pain while completing the movement on your left leg? </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('lowerBodyStabilityLeftPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('lowerBodyStabilityLeftPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('lowerBodyStabilityLeftPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('lowerBodyStabilityLeftPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['lowerBodyStabilityCountsRight'].dirty && formGroupProfile.controls['lowerBodyStabilityCountsRight'].errors">
                  <div class="cs_select-group">
                    <p><span class="required">*</span> How many single leg sit to stands on your right leg can you complete up to 10? </p>
                    <div class="cs_btn-group fill">
                      <input type="number" placeholder="e.g. 7" min="0" formControlName="lowerBodyStabilityCountsRight" id="lowerBodyStabilityCountsRight" />
                    </div>
                  </div>
                  <div class="error-message">Provide correct value</div>
                </div>
                  <div class="cs_select-group">
                    <p><span class="required">*</span> Did you experience any pain while completing the movement on your right leg? </p>
                    <div class="cs_btn-group">
                      <button class="cs_btn"
                              [ngClass]="formGroupProfile.get('lowerBodyStabilityRightPain')?.value === false ? 'primary' : 'secondary'"
                              (click)="formGroupProfile.get('lowerBodyStabilityRightPain')?.setValue(false)">
                        No
                      </button>

                      <button class="cs_btn"
                              [ngClass]="formGroupProfile.get('lowerBodyStabilityRightPain')?.value === true ? 'primary' : 'secondary'"
                              (click)="formGroupProfile.get('lowerBodyStabilityRightPain')?.setValue(true)">
                        Yes
                      </button>
                    </div>
                  </div>
                  <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                    <div class="error-message">Please answer all questions</div>
                  </div>
                </div>
              </div>
          </div>
        </div>


        <!--------------------------->
        <!-- Page  9 -->
        <!--------------------------->
        <div *ngIf="currentStep === 9" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item complete" (click)="goToStep(7)" [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(8)" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item  active" (click)="goToStep(9)" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(10)" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(11)" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(12)" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Ankle Mobility</h3>
                <div class="cs_step-label"> Step 3 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video"  (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/9f7b9424-f452-427e-af8c-fc02695e85c5/playlist.m3u8', 'Ankle Mobility Instruction')">
                  <div class="cs_play-video-label">Check Movement Instructions</div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Can you complete the movement by touching your left knee to the wall without your left
                    heel lifting off the floor?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityLeft')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityLeft')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityLeft')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityLeft')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while completing the movement to touch your left knee to the
                    wall?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityLeftPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityLeftPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityLeftPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityLeftPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Can you complete the movement by touching your right knee to the wall without your right
                    heel lifting off the floor?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityRight')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityRight')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityRight')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityRight')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while completing the movement to touch your right knee to the
                    wall?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityRightPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityRightPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('ankleMobilityRightPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('ankleMobilityRightPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="currentStep === 10" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item complete" (click)="goToStep(7)" [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(8)" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item  complete" (click)="goToStep(9)" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item active" (click)="goToStep(10)" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(11)" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(12)" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Single Leg Calf Raise</h3>
                <div class="cs_step-label"> Step 4 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video" (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/dbd8239d-bcb9-473f-8789-8ceaaa04d18c/playlist.m3u8', 'Single Leg Calf Raise Instruction')">
                  <div class="cs_play-video-label">Check Movement Instructions</div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['calfStrengthRaisesLeft'].dirty && formGroupProfile.controls['calfStrengthRaisesLeft'].errors">
                  <div class="cs_select-group">
                    <p><span class="required">*</span> How many single leg calf raises can you complete on your left leg up to 30? </p>
                    <div class="cs_btn-group fill">
                      <input type="number" placeholder="e.g. 25" min="0" formControlName="calfStrengthRaisesLeft" id="calfStrengthRaisesLeft" />
                    </div>
                  </div>
                  <div class="error-message">Provide correct value</div>
                </div>
                <div class="cs_select-group">
                  <p><span class="required">*</span> Did you experience any pain while completing the movement on your left leg? </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('calfStrengthLeftPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('calfStrengthLeftPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('calfStrengthLeftPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('calfStrengthLeftPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['calfStrengthRaisesRight'].dirty && formGroupProfile.controls['calfStrengthRaisesRight'].errors">
                  <div class="cs_select-group">
                    <p><span class="required">*</span> How many single leg calf raises can you complete on your right leg up to 30? </p>
                    <div class="cs_btn-group fill">
                      <input type="number" placeholder="e.g. 25" min="0" formControlName="calfStrengthRaisesRight" id="calfStrengthRaisesRight" />
                    </div>
                  </div>
                  <div class="error-message">Provide correct value</div>
                </div>
                <div class="cs_select-group">
                  <p><span class="required">*</span> Did you experience any pain while completing the movement on your right leg? </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('calfStrengthRightPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('calfStrengthRightPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('calfStrengthRightPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('calfStrengthRightPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="currentStep === 11" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item complete" (click)="goToStep(7)" [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(8)" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item  complete" (click)="goToStep(9)" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(10)" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item active" (click)="goToStep(11)" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item cs-not-visited" (click)="goToStep(12)" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Hip Stability</h3>
                <div class="cs_step-label"> Step 5 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video"  (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/e69f7686-ab2c-45c1-a3ed-b65ac23d52bd/playlist.m3u8', 'Hip Stability Instruction')">
                  <div class="cs_play-video-label">Check Movement Instructions</div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_select-group">
                  <p><span class="required">*</span> Can you hold the position with your left knee on the ground for at least 10 seconds? </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthLeft')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthLeft')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthLeft')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthLeft')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while holding the position with your left knee on the ground?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthLeftPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthLeftPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthLeftPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthLeftPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Can you hold the position with your right knee on the ground for at least 10 seconds?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthRight')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthRight')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthRight')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthRight')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_select-group">
                  <p>
                    <span class="required">*</span> Did you experience any pain while holding the position with your right knee on the
                    ground?
                  </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthRightPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthRightPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('hipStrengthRightPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('hipStrengthRightPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="currentStep === 12" class="content">
          <div class="cs-row sidebar">
            <div class="cs_panel column reset-padding cs_gap-0 visible-desktop">
              <button class="cs_sidebar-item complete" (click)="goToStep(7)" [class.error]="isPageInvalid(7)" [class.visited]="visitedSteps[7]">
                Hip Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(8)" [class.error]="isPageInvalid(8)" [class.visited]="visitedSteps[8]">
                Single Leg Sit to Stand <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(9)" [class.error]="isPageInvalid(9)" [class.visited]="visitedSteps[9]">
                Ankle Mobility <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(10)" [class.error]="isPageInvalid(10)" [class.visited]="visitedSteps[10]">
                Single Leg Calf Raise <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item complete" (click)="goToStep(11)" [class.error]="isPageInvalid(11)" [class.visited]="visitedSteps[11]">
                Hip Stability <div class="cs_sidebar-status">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
                </div>
              </button>
              <button class="cs_sidebar-item active" (click)="goToStep(12)" [class.error]="isPageInvalid(12)" [class.visited]="visitedSteps[12]">
                Plank <div class="cs_sidebar-status"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg></div>
              </button>
            </div>
            <div class="cs_panel column">
              <div class="cs_panel-header cs_panel-steps">
                <h3>Plank</h3>
                <div class="cs_step-label"> Step 6 of 6 </div>
              </div>
              <div class="cs_panel-body">
                <button class="cs_play-video"  (click)="openInstruction('https://wv-cdn-00-00.wowza.com/ea8c6bfa-c593-4e7f-9cb5-63eeeb7b20ec/cmaf/a00d417f-2f95-430e-8270-c88d3c5ee899/playlist.m3u8', 'Plank Instruction')">
                  <div class="cs_play-video-label">Check Movement Instructions</div> <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M9.5625 0C14.8438 0 19.125 4.28115 19.125 9.5625C19.125 14.8438 14.8438 19.125 9.5625 19.125C4.28115 19.125 0 14.8438 0 9.5625C2.25495e-07 4.28116 4.28116 2.25502e-07 9.5625 0ZM9.5625 1.51953C5.12063 1.51953 1.51953 5.12063 1.51953 9.5625C1.51953 14.0044 5.12063 17.6055 9.5625 17.6055C14.0044 17.6055 17.6055 14.0044 17.6055 9.5625C17.6055 5.12063 14.0044 1.51953 9.5625 1.51953ZM7.26562 5.8584C7.26606 5.3206 7.83716 4.99031 8.29395 5.22461L8.40527 5.29395L13.4082 8.93359C13.797 9.21697 13.797 9.79697 13.4082 10.0801L8.39453 13.7275C7.92526 14.0689 7.26594 13.7337 7.26562 13.1543V5.8584Z" fill="currentColor" /></svg>
                </button>
                <div class="cs_input-item" [class.has-error]="formGroupProfile.controls['coreSecondsStrength'].dirty && formGroupProfile.controls['coreSecondsStrength'].errors">
                  <div class="cs_select-group">
                    <p><span class="required">*</span> How long were you able to hold the plank position up to 120 seconds? </p>
                    <div class="cs_btn-group fill">
                      <input type="number" placeholder="e.g. 120" min="0" formControlName="coreSecondsStrength" id="coreSecondsStrength">
                    </div>
                  </div>
                  <div class="error-message">Provide correct value</div>
                </div>
                <div class="cs_select-group">
                  <p><span class="required">*</span> Did you experience any pain while holding the plank position? </p>
                  <div class="cs_btn-group">
                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('coreStrengthPain')?.value === false ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('coreStrengthPain')?.setValue(false)">
                      No
                    </button>

                    <button class="cs_btn"
                            [ngClass]="formGroupProfile.get('coreStrengthPain')?.value === true ? 'primary' : 'secondary'"
                            (click)="formGroupProfile.get('coreStrengthPain')?.setValue(true)">
                      Yes
                    </button>
                  </div>
                </div>
                <div class="cs_input-item" [class.has-error]="!isCurrentPageValid()">
                  <div class="error-message">Please answer all questions</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="currentStep === 13" class="content">
          <div class="container cs_complete-page ">
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M45.825 12.8326C37.7817 13.7177 30.2467 17.1892 24.3439 22.7235C18.4416 28.2551 14.4928 35.5535 13.0911 43.5218C12.2435 48.4861 12.3868 53.5722 13.515 58.4802C13.6521 59.1751 14.079 59.7766 14.6867 60.1381C15.2975 60.4996 16.0299 60.5868 16.7061 60.3749C17.9838 59.9667 18.7099 58.6236 18.3515 57.3334C17.4322 53.2416 17.2982 49.0093 17.9526 44.868C19.4173 35.7621 24.6933 27.7093 32.4595 22.7327C40.2224 17.7528 49.7427 16.3192 58.6276 18.7874C67.5157 21.2587 74.9295 27.3979 79.0118 35.6685C83.0973 43.9391 83.4619 53.5564 80.0184 62.1135C76.5748 70.6713 69.6504 77.3551 60.9777 80.4936C52.3018 83.6286 42.7036 82.9243 34.5822 78.549C33.4447 77.9756 32.0579 78.3527 31.3662 79.4216C30.9891 80.0355 30.8956 80.7834 31.1106 81.4721C31.3257 82.1609 31.8274 82.7218 32.4881 83.0116C42.9718 88.593 55.4802 88.861 66.1944 83.7377C76.9055 78.6144 84.5499 68.7075 86.7868 57.0463C89.0238 45.3851 85.5902 33.3529 77.531 24.63C69.4749 15.9038 57.7515 11.5256 45.9499 12.8315L45.825 12.8326Z" fill="#008000" />
              <path d="M43.9437 66.6293L70.62 40.028C71.586 39.0557 71.586 37.4851 70.62 36.5128C69.6477 35.5468 68.0771 35.5468 67.1048 36.5128L43.9443 59.6733C43.6857 59.9164 43.2806 59.9164 43.0219 59.6733L32.8997 49.4768C31.9273 48.5108 30.3567 48.5108 29.3845 49.4768C28.4184 50.4492 28.4184 52.0198 29.3845 52.992L43.0218 66.6293C43.2804 66.8724 43.6851 66.8724 43.9437 66.6293Z" fill="#008000" />
            </svg>
            <h1>Assessment Complete</h1>
            <p>Thank you! Your assessment has been submitted. <br> A summary of your results will be emailed to you shortly. </p>
            <button class="cs_btn" (click)="goToCreateAssessment()">Create Another Assessment</button>
          </div>
        </div>
      </form>
    </div>

    <footer *ngIf="currentStep != 13">
      <div class="container cs_footer" >
        <button class="cs_btn transparent secondary" *ngIf="!finished && currentStep != 0" (click)="previousStep()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15.0042 19.3608L7.64282 11.9995L15.0042 4.63818L16.3586 5.99268L10.3518 11.9995L10.592 12.2407L16.3586 18.0063L15.0042 19.3608Z" fill="currentColor" /></svg>
          Back
        </button>

        <button class="cs_btn transparent right" *ngIf="currentStep != 12" (click)="nextStep()" [disabled]="currentStep === steps.length - 1">
          Next <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M8.99585 4.63916L16.3572 12.0005L8.99585 19.3618L7.64136 18.0073L13.6482 12.0005L13.408 11.7593L7.64136 5.99365L8.99585 4.63916Z" fill="currentColor" /></svg>
        </button>

        <!--<button *ngIf="currentStep === 2 " (click)="onEarlySave(false)" class="cs_btn transparent right" [promiseBtn]="submitComplete">
          Skip and Submit
        </button>-->


        <!--<button *ngIf="currentStep === 6" (click)="onEarlySaveAssessmentAndProfile()" class="cs_btn transparent right" [promiseBtn]="submitComplete">
          Skip and Submit
        </button>-->

        <button *ngIf="currentStep === 12" (click)="onSaveAssessmentAndProfile()" class="cs_btn transparent right" [promiseBtn]="submitComplete">
          Finish Assessment
        </button>
      </div>
    </footer>
  </div>

  <div *ngIf="isLoading" class="overlay">
    <div class="spinner"></div>
  </div>
